import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  generalWrapper: {
    padding: "24px",
  },

  generalTitle: {
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: 600,
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Inter', sans-serif`,
  },
}));

export default styles;
